import * as React from "react";
import { IconProps } from "./IconProps";

export const IconChart = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.56328 1.54361C9.70931 1.41699 9.90311 1.35997 10.0944 1.38734C12.4315 1.72162 14.2784 3.56861 14.6127 5.90563C14.6401 6.09696 14.5831 6.29076 14.4565 6.43678C14.3298 6.58281 14.1461 6.66669 13.9528 6.66669H10C9.63185 6.66669 9.33337 6.36822 9.33337 6.00003V2.04729C9.33337 1.854 9.41726 1.67024 9.56328 1.54361ZM10.6667 2.89416V5.33336H13.1059C12.7042 4.19703 11.803 3.29584 10.6667 2.89416ZM6.66671 4.04729C4.40518 4.37077 2.66671 6.31571 2.66671 8.66669C2.66671 11.244 4.75605 13.3334 7.33337 13.3334C9.68436 13.3334 11.6293 11.5949 11.9528 9.33336H7.33337C6.96518 9.33336 6.66671 9.03488 6.66671 8.66669V4.04729ZM1.33337 8.66669C1.33337 5.35299 4.01967 2.66669 7.33337 2.66669C7.70156 2.66669 8.00004 2.96517 8.00004 3.33336V8.00003H12.6667C13.0349 8.00003 13.3334 8.2985 13.3334 8.66669C13.3334 11.9804 10.6471 14.6667 7.33337 14.6667C4.01967 14.6667 1.33337 11.9804 1.33337 8.66669Z"
          fill={color}
        />
      </svg>
    );
  },
);
